const getFileTypeDescription = type => {
  if (type === 'application/urb')
    return 'CityCAD urban model file';
  else if (type === 'curb')
    return 'CityCAD Compressed URB file';
  else if (type === 'application/urbresource')
    return 'CityCAD Resource file';
  else if (type === 'streetscape')
    return 'Streetscape Cross Section Model';
  else if (type === 'image/jpg' || type === 'image/jpeg' || type === 'image/png')
    return 'Image';
  else if (type === 'pdf' || type === 'application/pdf')
    return 'PDF Document';
  else if (type === 'word')
    return 'Word Document';
  else if (type === 'excel')
    return 'Excel Document';
  else if (type === 'powerpoint')
    return 'PowerPoint Document';
  else if (type === 'application/x-zip-compressed')
    return 'Zip Archive';
  else
    return type;
};

export default getFileTypeDescription;
